<template>
  <div>
    <h2 class="mt-5">Performance Objectives</h2>
    <placements-performance-item-read-only v-for="objective in objectives" :objective="objective" :key="objective.id"/>
  </div>
</template>

<script>
import { placementPerformanceObjectiveComputed, placementPerformanceObjectiveMethods, placementComputed } from 'vx/helpers'
import PlacementsPerformanceItemReadOnly from './PlacementsPerformanceItemReadOnly'

export default {
  components: {
    PlacementsPerformanceItemReadOnly
  },

  computed: {
    ...placementPerformanceObjectiveComputed,
    ...placementComputed
  },

  async created () {
    await this.getPerformanceObjectives()
  },

  methods: {
    ...placementPerformanceObjectiveMethods
  }
}
</script>
